import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-energy/15 bg-navy-light py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="9t1ptdkbepep">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-energy/40 bg-navy-card p-8 shadow-2xl sm:p-12" data-id="element-75" data-mp="etplicjhnuf9">
          <span className="inline-flex rounded-full border border-aqua/50 bg-navy p-4 text-energy" data-id="element-76" data-mp="slm9q5i1dk6d">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-77" data-mp="xm1o90e20xpx" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-balance text-3xl font-extrabold uppercase tracking-tight text-cream sm:text-4xl" data-id="element-78" data-mp="12kl90xgww3gp">
            Garanzia di soddisfazione <span className="text-gold" data-id="element-79" data-mp="25s708e6i5769">di 7 giorni</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-haze" data-id="element-80" data-mp="20su6d9h7qzu6">
            Se entro 7 giorni il materiale non fa per te,{' '}
            <span className="font-extrabold text-gold" data-id="element-81" data-mp="1vszfh5xfua94">ti rimborsiamo. Senza domande.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}